import { isJson } from 'ava-util/dist/data';
import { getParamInSearch } from 'ava-util/dist/request';
import { DEBUG_TRACKER } from 'base/config/constant';
import site from 'pro/config/site';
import { IStartTrackDataFull } from 'mod/track/interface';

/*
* 通用 schema 文档：https://github.com/snowplow/iglu-central/tree/master/schemas
* Ecommerce打点参考文档：https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/web-tracker/tracking-events/ecommerce/enhanced/
* 自定义 schema 文档：https://e.gitee.com/sinowell/repos/sinowell/iglu-schemas/tree/master/iglu-vivosun/schemas/com.vivosun
* */

declare const window: any;

// const SP_USER_INFO_FIRST_SESSION = 0;
// const SP_USER_INFO_DOMAIN_USERID = 1;
// const SP_USER_INFO_COOKIE_CREATED_AT = 2;
// const SP_USER_INFO_VISIT_NO = 3;
// const SP_USER_INFO_CURRENT_VISIT_TSTAMP = 4;
// const SP_USER_INFO_LAST_VISIT_TSTAMP = 5;
const SP_USER_INFO_DOMAIN_SESSIONID = 6;
// const SP_USER_INFO_PREV_DOMAIN_SESSIONID = 7;
// const SP_USER_INFO_SESSION_FIRST_EVTID = 8;
// const SP_USER_INFO_SESSION_FIRST_EVT_DVCE_CREATED_AT = 9;
// const SP_USER_INFO_SESSION_LAST_EVT_INDEX = 10;

export type ISpPageViewData = {
    viewType: string;
    canonicalUrl: string;
    detail?: string | number;
    // userTags: string; 移到global-context中，pageView不需要了
}

export type ISpStructEvent = {
    category: string;
    action: string;
    label?: string;
    property?: string;
    value?: number | string;
};
export type TSpElementAction = 'impr' | 'click';
export type ISpElementData = {
    action?: TSpElementAction;
    targetType: string;
    target: string;
    relTarget?: string;
    module?: string;
    position?: string | number;
    creative?: string;
    content?: string;
    value?: string | number;
};

let isStarted = false; //是否开始发送数据
let todoFunctions: Function[] = []; //等待执行的回调

/**
 * 运行 todoFunctions 中保存你的等待执行的回调函数
 */
function runCallbacks(): void {
    // 执行待执行的回调
    if (todoFunctions.length && window.snowplow) {
        todoFunctions.map(callback => callback());
        todoFunctions = [];
    }
}

/**
 * 调用 window.snowplow 方法发送数据
 * @param methodName snowplow api中的 method
 * @param data context对应的的数据 或 自定义context
 */
function track(methodName: string, data?: any) {
    data = typeof data === 'function' ? data() : data;

    if (getParamInSearch(DEBUG_TRACKER) === 'ctr' && methodName === 'trackSelfDescribingEvent') {
        // data.context.forEach((item: any) => {
        //     console.table(item.data);
        // });
        console.table(data.context.map(item => item.data));

    } else if (getParamInSearch(DEBUG_TRACKER) === '1') {
        console.log(`-----SP: ${methodName} -----`);
        if (data) {
            console.log(JSON.stringify(data, null, 4));
        }
    }
    if (window.snowplow) {
        return window.snowplow(methodName, data);
    }
}

/**
 * 发送数据前验证是否符合发送条件，不符合条件的暂时保存在 todoFunctions 数组中
 * @param methodName snowplow api中的 method
 * @param data 要发送的数据
 */
function trackOrDelay(methodName: string, data: any) {
    // 主动触发 start 之前，放到数组中等待执行
    if (isStarted) {
        track(methodName, data);
    } else {
        todoFunctions.push(function() {
            track(methodName, data);
        });
    }
}

export function getSpClientId(): Promise<string> {
    return new Promise((resolve, reject) => {
        if (window.snowplow) {
            let success = false;

            window.snowplow(function() {
                success = true;
                // @ts-ignore
                const clientId = this[site.sp.projectName].getDomainUserId();

                resolve(clientId);
            });

            setTimeout(() => {
                if (!success) {
                    reject('Snowplow is blocked.');
                }
            }, 200);

        } else {
            reject('Snowplow is uninstalled.');
        }
    })
}

export function getSpUserInfo(): Promise<Array<string>> {
    return new Promise((resolve, reject) => {
        if (window.snowplow) {
            let success = false;

            window.snowplow(function() {
                success = true;

                // @ts-ignore
                // https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/web-tracker/previous-versions/javascript-tracker-v3/advanced-usage/tracker-callbacks/#getdomainuserinfo
                const userInfo = this[site.sp.projectName].getDomainUserInfo();
                resolve(userInfo);
            });
            setTimeout(() => {
                if (!success) {
                    reject('Snowplow is blocked.');
                }
            }, 200);
        } else {
            reject('Snowplow is uninstalled.');
        }
    })
}

export function getSpSessionId(): Promise<string> {
    return getSpUserInfo().then(userInfo => userInfo[SP_USER_INFO_DOMAIN_SESSIONID]);
}

export function getSpAppId(): string {
    return site.sp.appId[process.env.NEXT_PUBLIC_ENV_NAME === 'prod' ? 'prod' : 'test']
}

/**
 * 开始发出打点请求，参考文档：https://e.gitee.com/sinowell/repos/sinowell/iglu-schemas/tree/master/iglu-vivosun/schemas/com.vivosun/global-context/jsonschema
 */
export function spStartTrack(data: IStartTrackDataFull) {
    const {
        userId,
        userTags,
        lang,
        country,
    } = data;
    track('clearGlobalContexts'); // remove all global contexts

    track('setUserId', userId);
    track('addGlobalContexts', [{
        schema: 'iglu:com.vivosun/global-context/jsonschema/1-0-2',
        data: {
            userTags,
            language: lang,
            country,
            appId: getSpAppId(),
        }
    }]);

    if (!isStarted) {
        isStarted = true;
        runCallbacks();
    }
}

/**
 * 页面曝光事件，参考文档：https://e.gitee.com/sinowell/repos/sinowell/iglu-schemas/blob/master/iglu-vivosun/schemas/com.vivosun/ecommerce-context/jsonschema
 * @param pageCode 页面code
 * @param config 配置
 */
export function spPageView(data: ISpPageViewData) {
    trackOrDelay('trackPageView', {
        context: [{
            schema: 'iglu:com.vivosun/ecommerce-context/jsonschema/1-0-7',
            data
        }]
    });
}

// 商品列表Impression
export function spProductsImpression(action: string, data: Record<string, any> | Record<string, any>[]) {
    if (isJson(data)) {
        trackOrDelay('addEnhancedEcommerceImpressionContext', data);
    } else {
        data.forEach((item: any) => {
            trackOrDelay('addEnhancedEcommerceImpressionContext', item);
        });
    }
    trackOrDelay('trackEnhancedEcommerceAction', { action })
}

// 商品列表中点击商品链接
export function spProductClick(data: Record<string, any>) {
    trackOrDelay('addEnhancedEcommerceProductContext', data);
    trackOrDelay('trackEnhancedEcommerceAction', { action: 'click' })
}

// 添加购物车/移除购物车商品
export function spCartItem(action: string, data: Record<string, any> | Record<string, any>[]) {
    if (isJson(data)) {
        trackOrDelay('addEnhancedEcommerceProductContext', data);
    } else {
        data.forEach((item: any) => {
            trackOrDelay('addEnhancedEcommerceProductContext', item);
        });
    }
    trackOrDelay('trackEnhancedEcommerceAction', { action })
}

// 下单流程中的步骤
export function spCheckout(action: string, list: Record<string, any>[], orderInfo: Record<string, any>) {
    list.forEach((item: any) => {
        trackOrDelay('addEnhancedEcommerceProductContext', item);
    });
    trackOrDelay('addEnhancedEcommerceActionContext', orderInfo);
    trackOrDelay('trackEnhancedEcommerceAction', { action })
}

// Subscribe
export function spStructEvent(data: ISpStructEvent) {
    trackOrDelay('trackStructEvent', data);
}

/*
* CTR 打点，参考文档：https://e.gitee.com/sinowell/repos/sinowell/iglu-schemas/tree/master/iglu-vivosun/schemas/com.vivosun/action/jsonschema
* */
export function spElement(data: Record<string, any>) {
    trackOrDelay('trackSelfDescribingEvent', data);
}



